import { usePlaces } from "./usePlaces";

export const usePlacesOptions = () => {
  const { isLoading, places } = usePlaces(0, 1_000_000);

  const options = places
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((x) => ({
      value: x.id.toString(),
      label: x.name,
    }));

  return { loading: isLoading, options };
};
